module.exports = __webpack_public_path__ + "static/media/mockup-remedios-dark.561f1602.png";